import React from 'react'

import { PaperClipIcon } from '@heroicons/react/20/solid'

const GridPedidos = ({ setShowDatosFactura, pedidos, handleFacturaData, datosFactura, sendFacturas }) => {
  return (
    <div className="transition duration-500 ease elementFadeIn overflow-hidden bg-primarioMira shadow sm:rounded-lg mx-auto">
      <div className="px-4 py-6 sm:px-6">
        <h3 className="text-base font-semibold leading-7 text-gray-100">Información de la factura</h3>
        <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">Los pedidos seleccionados son los que se muestran a continuación, ingrese fecha y factura</p>
      </div>
      <div className="border-t border-gray-600">
        <dl className="divide-y divide-gray-600">
            {pedidos.map((e, index) => (
          <div className="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <div className="text-sm text-gray-100">
              <p className='font-medium'>#{e['IdEnvio']}</p>
              <ul>
                {e.Productos.map((elemento) => (
                  <li className=''>
                 {`${elemento['Producto']}`}
                </li>)
                )}
              </ul>
              </div>
            
            <dd className="mt-1 text-sm leading-6 text-gray-400 sm:col-span-2 sm:mt-0 self-end">
              <div className='flex flex-col'>
                <div className='flex flex-row justify-between gap-2'>
                  <p>{`${e['Proveedor']} - ${e['Bodega']}`}</p>
                  <p className='text-xl'>{Intl.NumberFormat('es-GT', {style:"currency", currency: "GTQ"}).format(e.Productos.reduce((p,n) => p + n.Costo, 0)) }</p>
                </div>
                
              </div>
            </dd>
          </div>
            ))}
            {/*<dd className="mt-1 text-sm leading-6 text-gray-400 sm:col-span-2 sm:mt-0">
                <div className="px-4 py-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-100 my-auto">Total</dt>
                    <div className='flex flex-row justify-end w-full'>
                      <p className='text-3xl font-medium'>{Intl.NumberFormat('es-GT', {style:"currency", currency: "GTQ"}).format(pedidos.map(e => e.Productos.reduce((p, n) => p +n.Costo, 0)).reduce((p,n) => p+n,0)) }</p>
                    </div>
                </div>
            </dd>
            */}
            {/*
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-100">About</dt>
                <dd className="mt-1 text-sm leading-6 text-gray-400 sm:col-span-2 sm:mt-0">
                  Fugiat ipsum ipsum deserunt culpa aute sint do nostrud anim incididunt cillum culpa consequat. Excepteur
                  qui ipsum aliquip consequat sint. Sit id mollit nulla mollit nostrud in ea officia proident. Irure nostrud
                  pariatur mollit ad adipisicing reprehenderit deserunt qui eu.
                </dd>
              </div>
          */}
          <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium leading-6 text-gray-100">Datos de la factura</dt>
            <dd className="mt-2 text-sm text-gray-100 sm:col-span-2 sm:mt-0">
              <ul role="list" className="divide-y divide-gray-600 rounded-md border border-gray-600">
                <li className="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                  <div className="flex w-0 flex-1 items-center">
                    {/*<PaperClipIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />*/}

                    <div className="ml-4 flex min-w-0 flex-1 gap-2 flex-col">
                      <span className="truncate font-medium">Fecha de factura</span>
                      <input 
                        type="date"
                        min="1900-01-01"
                        max="2099-01-01"
                        name={"fechaFactura"} 
                        className='rounded-md p-2 text-gray-800'
                        onChange={(e) => handleFacturaData(e)}
                        value={datosFactura["fechaFactura"]}
                      ></input>
                    </div>
                    <div className="ml-4 flex min-w-0 flex-1 gap-2 flex-col">
                      <span className="truncate font-medium">Fecha de vencimiento</span>
                      <input 
                        type="date"
                        min="1900-01-01"
                        max="2099-01-01"
                        name={"fechavence"} 
                        className='rounded-md p-2 text-gray-800'
                        onChange={(e) => handleFacturaData(e)}
                        value={datosFactura["fechavence"]}
                      ></input>
                    </div>

                  </div>
                </li>
                <li className="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                  <div className="flex w-0 flex-1 items-center">
                    {/*<PaperClipIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />*/}
                    <div className="ml-4 flex min-w-0 flex-1 gap-2 flex-col">
                      <span className="truncate font-medium">Factura</span>
                      <input 
                        type="text" 
                        name={"factura"} 
                        className='rounded-md p-2 text-gray-800'
                        onChange={(e) => handleFacturaData(e)}
                        value={datosFactura["factura"]}
                      ></input>
                    </div>
                  </div>
                </li>
              </ul>
            </dd>
          </div>
            <div className="flex flex-row justify-between w-full p-5">
                        <button 
                          className="py-2 px-4 rounded-md px-auto py-auto text-center text-md text-gray-100 hover:bg-secundario bg-azulBrillanteMira flex flex-row /justify-center   transition duration-500 ease "
                          onClick={() => setShowDatosFactura(false)}
                        >Atrás
                        </button>
                        {Object.values(datosFactura).every(e => e !== "")?
                        <button 
                        className="py-2 px-4 rounded-md px-auto py-auto text-center text-md text-gray-100 hover:bg-secundario bg-azulBrillanteMira flex flex-row /justify-center   transition duration-500 ease "
                        onClick={() => sendFacturas()}
                        >Aceptar
                        </button>
                    : null}
            </div>
        </dl>
      </div>
    </div>
  )
}


export default GridPedidos